// extracted by mini-css-extract-plugin
export default {"spinner":"loading_spinner__-+7IQ","spinner2":"loading_spinner2__9vxRI"};